import { useTranslation } from 'react-i18next';

import LoadingPage from '@/components/common/LoadingPage';
import SubPageHeader from '@/components/common/SubPageHeader';
import OnesuranceIcon from '@/components/icons/Onesurance';
import { useEmail } from '@/components/providers/EmailProvider/EmailProvider';
import useSelectedParty from '@/features/analysis/hooks/useSelectedParty';
import hasItems from '@/lib/utils/hasItems';

import useOnesuranceRecommendations from '../../queries/hooks/useOnesuranceRecommendation';
import OnesuranceAdvice from '../OnesuranceAdvice/OnesuranceAdvice';

import RecommendationContent from './RecommendationContent';

export default function OnesuranceRecommendations() {
  const { t } = useTranslation();
  const {
    analysis: { email, analysis },
  } = useEmail();
  const party = useSelectedParty();

  const isAnalysisForSelectedParty =
    Boolean(party?.id) && analysis?.party_id === party?.id;

  const { data, isLoading } = useOnesuranceRecommendations(email?.id ?? '', {
    enabled: Boolean(email?.id) && isAnalysisForSelectedParty,
  });

  const { recommendations, advice } = data ?? {};

  if (!isAnalysisForSelectedParty) return null;
  if (!hasItems(recommendations)) return null;

  const churnDot = recommendations?.find(
    (rec) => rec.level === 'HIGH' && rec.type === 'CHURN',
  );
  const salesDot = recommendations?.find(
    (rec) => rec.level === 'HIGH' && rec.type === 'SALES',
  );

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <SubPageHeader className="items-center gap-2">
        <OnesuranceIcon className="size-4" />

        {t('ONESURANCE_RECOMMENDATIONS_TITLE')}

        <div className="flex items-center gap-1">
          {churnDot && <span className="size-1.5 rounded-lg bg-red-500" />}

          {salesDot && <span className="size-1.5 rounded-lg bg-green-500" />}
        </div>
      </SubPageHeader>

      <main className="flex flex-1 flex-col gap-2 overflow-y-auto">
        {isLoading && <LoadingPage />}

        {!isLoading && (
          <div className="flex flex-col">
            <RecommendationContent recommendations={recommendations} />

            <OnesuranceAdvice advice={advice} />
          </div>
        )}
      </main>
    </div>
  );
}
